(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(root) {
    const video = root.querySelector('[data-stkr-hero-video]');
    const button = root.querySelector('[data-stkr-hero-toggle]');
    if (!video || !button || video.dataset.motionControlReady) return;
    video.dataset.motionControlReady = 'true';

    function updateButton() {
      const label = video.paused ? 'Play motion' : 'Pause motion';
      button.setAttribute('aria-label', label);
      button.dataset.paused = String(video.paused);
    }

    function applyPreference() {
      if (reducedMotion.matches) {
        video.pause();
      } else if (video.dataset.userPaused !== 'true') {
        video.play().catch(updateButton);
      }
      updateButton();
    }

    button.addEventListener('click', () => {
      if (video.paused) {
        delete video.dataset.userPaused;
        video.play().catch(updateButton);
      } else {
        video.dataset.userPaused = 'true';
        video.pause();
      }
      updateButton();
    });
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    reducedMotion.addEventListener('change', applyPreference);
    applyPreference();
  }

  document.querySelectorAll('.stkr-halloween-campaign__hero-media').forEach(setup);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.stkr-halloween-campaign__hero-media').forEach(setup);
  });
})();
